export const GLOBAL_STATE = 'City'

export const CITY = 'city'
export const CITY_LIST = 'cityList'
export const CITY_ALL = 'cityAll'
export const CITY_CREATE = 'cityCreate'
